<template>
  <div class="PrivateLayout">
    <AppHeader />
    <div class="PageContainer">

      <slot name="banner" />

      <LazyUnsavedChangesModal
        v-if="dialogRevealed"
        :message="unsavedChangesMessage"
        @confirm="confirmDialog()"
        @cancel="cancelDialog()"
      />

      <KeepPlanModalGroup />

      <LazyOutstandingBalanceModalGroup v-if="outstandingBalanceStatus" />

      <LazyOffboardingModalGroup
        v-if="cancelFlowLoaded && offboardingStore.subscriptionToCancel"
        :subscription="offboardingStore.subscriptionToCancel"
      />

      <div class="PrivateLayout-container">
        <aside class="PrivateLayout-sidebar">
          <AppNavigation />
          <slot name="sidebar" />
        </aside>

        <main class="PrivateLayout-content u-container">
          <slot />
        </main>

      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { watchOnce } from '@vueuse/core';

const { isRevealed: dialogRevealed, confirm: confirmDialog, cancel: cancelDialog, onReveal } = provideUnsavedChangesDialog();
const unsavedChangesMessage = ref('');
onReveal((msg: string) => {
  unsavedChangesMessage.value = msg ?? '';
});

const offboardingStore = useOffboardingStore();
const { status: outstandingBalanceStatus } = useOutstandingBalance();

const cancelFlowLoaded = ref(false);
watchOnce(() => offboardingStore.cancelFlowOpened, (val) => {
  if (val) cancelFlowLoaded.value = true;
});
</script>

<style lang="scss">
@use 'assets/scss/theme' as vars;
@use '@cvo/ui/styles/utils/responsive';

@layer cvo-base {
  .PrivateLayout {
    background-color: vars.$templates-privatepage-bg-color;

    &-container {
      display: flex;
      gap: vars.$dimensions-d-8;
    }

    &-sidebar {
      flex-shrink: 0;
      @include responsive.mobile {
        display: none;
      }
    }

    &-content {
      padding: 0;
      flex: 1;
      min-width: 0; // Prevent flex item from overflowing

      @include responsive.tablet-down {
        width: 100%;
      }
    }
  }
}
</style>
